import { useLibby } from "@phinxlab/libby-rest-web";
import { LibbyObject } from "../../../commons/types";

export const makeEntityLibbyDAO = (daoName: string) => (): LibbyObject => {
  const { libby } = useLibby([daoName]);
  return libby[daoName];
};
